import React from 'react'
import "./tableModule.css"

const Table = ({colms, items, heading}) => {

    return (
        <div className='tbl-v1'>
            <table>
                <caption>{heading}</caption>
                <thead>
                    <tr>{colms.map(item=><th className={item.key} scope="col">{item.displayName}</th>)}</tr>
                </thead>
                <tbody>
                    {items.map((rowData,i)=><tr>
                        {colms.map(item=><td>{typeof rowData[item.key]==="boolean"?(rowData[item.key]?"Yes":"No"):rowData[item.key]}</td>)}
                    </tr>)}
                </tbody>
            </table>
        </div>
    )
}

export default Table
